import React, { memo as Memo, useMemo, useRef, useEffect, useState } from 'react'

//* HOC's
import withDataContext from '@context/consumerHOC/DataConsumer'
import withUIContext from '@context/consumerHOC/UIConsumer'

//* Helpers
import { config, hoverBtn } from 'helpers'

//* Components
import Page from '@components/global/Page'
import Text from '@components/global/Text'
import CustomLink from '@components/global/CustomLink'
import CustomImage from '@components/global/CustomImage'
import Shape from '@components/global/Shape'

import Team from '@components/pages/About/TeamSection'
import AnimTextBottomFirst from '@components/pages/About/AnimTextBottomFirst'
import AnimTextTop from '@components/pages/About/AnimTextTop'
import SnakeGame from '@components/pages/About/SnakeGame'
import WeDo from '@components/sections/WeDo'
import Canvas from '@components/pages/Portfolio/Canvas'

//* Style
import AboutStyle from '@styles/pages/aboutStyle'

const About = Memo(({ pages, pageParams, activeColorObj, winWidth, winHeight }) => {
	//! Page data
	const pageData = useMemo(() => pages?.[pageParams.name], [pages, pageParams.name])

	//! Refs
	const blockRef = useRef()
	const btnText = useRef()

	//! States
	const [firstTime, setFirstTime] = useState(true)

	const bgColor = useMemo(() => activeColorObj.color, [activeColorObj])

	useEffect(() => {
		window.addEventListener('scroll', scroll)

		return () => {
			window.removeEventListener('scroll', scroll)
		}
	}, [firstTime])

	const scroll = () => {
		if (blockRef?.current?.getBoundingClientRect().y < winHeight && firstTime) {
			setFirstTime(false)
		} else if (blockRef?.current?.getBoundingClientRect().y < -50 && !firstTime) {
			setFirstTime(true)
		}
	}

	const letterify = () => {
		let lettersArr = []

		for (let i = 0; i < btnText?.current?.attributes?.dataword?.nodeValue.length; i++) {
			lettersArr.push(btnText?.current?.attributes?.dataword?.nodeValue.charAt(i))
		}

		return lettersArr.map((i, k) => {
			return (
				<span key={k} className='letter'>
					{i}
				</span>
			)
		})
	}
	return (
		<AboutStyle>
			<Page className='about' meta={pageData?.content?.meta}>
				{pageData && (
					<>
						<div className='top flexBoxColumn'>
							<Text tag={'h1'} className={'uppercase h1 Neue'} text={'WE ARE CHUKSTER'} />
							<AnimTextTop />
						</div>

						<div className='snake padding-style' style={{ backgroundColor: bgColor }}>
							{winWidth > 1279 ? (
								<SnakeGame bgColor={bgColor} percentageWidth={50} startSnakeSize={6} speed={100} winWidth={winWidth} />
							) : null}

							<Text tag={'h5'} className={'snake-text h5 Neue pre-wrap'} text={pageData.content.text} />

							{winWidth > 1279 ? (
								<div className='controls flexBoxColumn'>
									<div className='buttons flexBoxWrap'>
										<div className='top-btn'></div>
										<div className='left-btn'></div>
										<div className='bottom-btn'></div>
										<div className='right-btn'></div>
									</div>
									<Text tag={'p'} className={'help-text p Neue'} text={'Use your keys to move the snake'} />
								</div>
							) : (
								<CustomImage alt='snake svg' className='snake-svg' src='/images/about/snakeTablet.svg' />
							)}
						</div>

						{pageData.teamMembers?.length > 0 ? <Team data={pageData.teamMembers} /> : null}

						{pageData.services?.length > 0 ? (
							<WeDo
								isNameMeaning
								servicesArr={pageData.services}
								nameMeaning={pageData.content.name_meaning}
								file={pageData.content.service_file}
							/>
						) : null}

						<div ref={blockRef} className='bottom flexBoxColumn'>
							{pageData ? <Canvas canvasHeight={blockRef?.current?.clientHeight} bgColor={bgColor} /> : null}

							<Text tag={'h2'} className={'first uppercase h2 Neue'} text={'Like master criminals,'} />

							<Text tag={'h2'} className={'second-t uppercase h2 Neue'} text={'we unlock brand potential'} />

							<Text tag={'h2'} className={'third uppercase h2 Neue'} text={'and steal'} />

							<div className='block'>
								<Text tag={'h2'} className={'fourth uppercase h2 Neue'} text={'your customer’s'} />
								<AnimTextBottomFirst />
							</div>

							<CustomLink
								onMouseEnter={() => hoverBtn(true, btnText.current)}
								onMouseLeave={() => hoverBtn(false, btnText.current)}
								url={config.routes.contact.path}
								className='btn btn-black full'
							>
								{winWidth > 1279 ? (
									<>
										<Shape src={'/images/heart.svg'} />
										<Shape src={'/images/heart.svg'} />
										<Shape src={'/images/heart.svg'} />
										<Shape src={'/images/heart.svg'} />
										<Shape src={'/images/heart.svg'} />
										<Shape src={'/images/heart.svg'} />
										<Shape src={'/images/heart.svg'} />
										<Shape src={'/images/heart.svg'} />
									</>
								) : null}

								<div className='block'>
									<Text ref={btnText} tag={'h3'} className={'orig h3 Neue'} dataword={'Get in touch'}>
										{letterify()}
									</Text>

									<Text tag={'h3'} className={'copy h3 Neue'} text={'Get in touch'} />
								</div>
							</CustomLink>
						</div>
					</>
				)}
			</Page>
		</AboutStyle>
	)
})

export default withUIContext(withDataContext(About, ['pages']), ['activeColorObj', 'winWidth', 'winHeight'])
